var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"elevation":"15"},on:{"click":function($event){return _vm.submitUserFeedback()}}},[_vm._v(" give feedback ")])}
var staticRenderFns = []

export { render, staticRenderFns }